var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScienceLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 124,
    viewBox: "0 0 190 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.14 38.1799L171.46 34.1699L170.82 41.0999L177.14 38.1799Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.52 8.47961C167.453 8.47961 168.21 7.72297 168.21 6.78961C168.21 5.85625 167.453 5.09961 166.52 5.09961C165.587 5.09961 164.83 5.85625 164.83 6.78961C164.83 7.72297 165.587 8.47961 166.52 8.47961Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1198 58.1002C54.4898 63.8902 56.6498 72.9202 56.6498 83.0802C56.6498 100.55 50.2398 114.71 42.3298 114.71C34.4198 114.71 28.0098 100.55 28.0098 83.0802C28.0098 65.6102 34.4198 51.4502 42.3298 51.4502C43.3498 51.4502 44.3398 51.6802 45.2998 52.1302",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6099 86.8794C21.8699 81.6694 27.2699 76.1095 34.1299 71.3295C48.4599 61.3295 63.7399 58.4795 68.2699 64.9695C72.7999 71.4595 64.8599 84.8195 50.5299 94.8195C36.1999 104.819 20.9199 107.669 16.3899 101.179C15.1499 99.4095 14.8499 97.1295 15.3399 94.5395",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7899 105.07C52.8699 105.14 43.1199 101.42 33.8499 94.6197C19.7699 84.2797 12.1499 70.7297 16.8299 64.3497C21.5099 57.9697 36.7199 61.1897 50.8099 71.5297C64.8999 81.8697 72.5099 95.4197 67.8299 101.8",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9303 91.4397C47.5474 91.4397 51.2903 87.6968 51.2903 83.0797C51.2903 78.4626 47.5474 74.7197 42.9303 74.7197C38.3132 74.7197 34.5703 78.4626 34.5703 83.0797C34.5703 87.6968 38.3132 91.4397 42.9303 91.4397Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2601 95.0094C19.5686 95.0094 21.4401 93.138 21.4401 90.8294C21.4401 88.5209 19.5686 86.6494 17.2601 86.6494C14.9515 86.6494 13.0801 88.5209 13.0801 90.8294C13.0801 93.138 14.9515 95.0094 17.2601 95.0094Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3001 59.1998C50.6087 59.1998 52.4801 57.3284 52.4801 55.0198C52.4801 52.7113 50.6087 50.8398 48.3001 50.8398C45.9916 50.8398 44.1201 52.7113 44.1201 55.0198C44.1201 57.3284 45.9916 59.1998 48.3001 59.1998Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9996 103.97C67.9996 106.28 66.1296 108.15 63.8196 108.15C61.8996 108.15 60.2796 106.85 59.7896 105.08C59.6896 104.73 59.6396 104.36 59.6396 103.97C59.6396 101.66 61.5096 99.79 63.8196 99.79C66.1196 99.79 67.9996 101.66 67.9996 103.97Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4 34.2813H98.55C96.84 34.2813 95.46 32.9013 95.46 31.1913V30.4113C95.46 28.7013 96.84 27.3213 98.55 27.3213H102.64",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13 34.2812H104.16V52.8313L80.1399 98.1213C77.4899 103.111 81.1099 109.121 86.7599 109.121H132C137.65 109.121 141.26 103.111 138.62 98.1213L129.41 80.7213",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38 54.2914L114.6 52.8314V42.4414",
    stroke: "#91A7FF",
    strokeWidth: 1.4216,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6797 74.4805C92.6797 74.4805 98.8497 69.0905 105.81 76.0505C112.77 83.0105 126.31 79.1805 126.31 79.1805",
    stroke: "#748FFC",
    strokeWidth: 1.5462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.48 93.461C119.57 93.461 118 91.891 118 89.981C118 88.071 119.57 86.501 121.48 86.501C123.39 86.501 124.96 88.071 124.96 89.981C124.96 91.891 123.39 93.461 121.48 93.461Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77 74.3111C113.73 74.3111 114.51 73.5311 114.51 72.5711C114.51 71.6111 113.73 70.8311 112.77 70.8311C111.81 70.8311 111.03 71.6111 111.03 72.5711C111.03 73.5311 111.82 74.3111 112.77 74.3111Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74 76.5609C150.3 74.9909 151.26 72.8309 151.26 70.4409C151.26 67.4409 149.74 64.7909 147.42 63.2309C148.71 61.9709 149.51 60.2109 149.51 58.2609C149.51 54.9509 147.19 52.1909 144.1 51.4809C145.29 49.9909 146.03 48.1309 146.03 46.0709C146.03 41.2609 142.13 37.3709 137.33 37.3709C135.92 37.3709 134.61 37.7409 133.43 38.3309C132.85 36.4409 131.69 34.8109 130.1 33.7109C130.26 33.2109 130.36 32.7009 130.36 32.1509C130.36 29.2709 128.02 26.9309 125.14 26.9309C124.4 26.9309 123.7 27.0909 123.06 27.3709C122.11 24.1109 119.14 21.7109 115.57 21.7109C113.06 21.7109 110.85 22.9109 109.41 24.7509C108.49 23.9509 107.31 23.4509 105.99 23.4509C103.11 23.4509 100.77 25.7909 100.77 28.6709C100.77 31.5509 103.11 33.8909 105.99 33.8909C106.96 33.8909 107.87 33.6109 108.65 33.1409C109.5 34.7609 110.86 36.0609 112.56 36.7709C111.72 37.9209 111.21 39.3209 111.21 40.8509C111.21 44.5309 114.08 47.5209 117.7 47.7609C114.84 49.6209 112.95 52.8409 112.95 56.5109C112.95 56.8309 112.97 57.1409 113 57.4509C110.9 58.6509 109.47 60.8809 109.47 63.4709C109.47 67.3109 112.59 70.4309 116.43 70.4309C117.85 70.4309 119.17 70.0009 120.27 69.2709C120.04 70.2009 119.91 71.1709 119.91 72.1709C119.91 78.9009 125.36 84.3509 132.09 84.3509C133.97 84.3509 135.75 83.9109 137.35 83.1509C137.35 83.2609 137.32 83.3709 137.32 83.4809C137.32 87.8109 140.83 91.3109 145.15 91.3109C149.48 91.3109 152.98 87.8009 152.98 83.4809C153 80.4609 151.26 77.8609 148.74 76.5609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79 71.3896H175.05C174.33 71.3896 173.74 70.7996 173.74 70.0796V69.4096C173.74 68.6896 174.33 68.0996 175.05 68.0996H187.79C188.51 68.0996 189.1 68.6896 189.1 69.4096V70.0796C189.1 70.7996 188.51 71.3896 187.79 71.3896Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2 108.71H180.64C178.95 108.71 177.58 107.34 177.58 105.65V71.3896H185.26V105.65C185.26 107.33 183.89 108.71 182.2 108.71Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.811 93.6494H184.711",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.97 71.3896H156.23C155.51 71.3896 154.92 70.7996 154.92 70.0796V69.4096C154.92 68.6896 155.51 68.0996 156.23 68.0996H168.97C169.69 68.0996 170.28 68.6896 170.28 69.4096V70.0796C170.28 70.7996 169.7 71.3896 168.97 71.3896Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.38 108.71H161.82C160.13 108.71 158.76 107.34 158.76 105.65V71.3896H166.44V105.65C166.44 107.33 165.07 108.71 163.38 108.71Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.41 84.8691H159.479",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.02 98.6698C161.02 96.5398 163.25 96.5399 163.25 94.4099C163.25 92.2799 161.02 92.2798 161.02 90.1498C161.02 88.0198 163.25 88.0198 163.25 85.8798C163.25 83.7498 161.02 83.7498 161.02 81.6098C161.02 79.4798 163.25 79.4798 163.25 77.3398",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8702 82.17C81.6765 82.17 82.3302 81.5163 82.3302 80.71C82.3302 79.9037 81.6765 79.25 80.8702 79.25C80.0638 79.25 79.4102 79.9037 79.4102 80.71C79.4102 81.5163 80.0638 82.17 80.8702 82.17Z",
    stroke: "#748FFC",
    strokeWidth: 0.9726,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24023 35.9492L38.3102 41.7392",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6299 1.31055L97.7499 18.8405",
    stroke: "#748FFC",
    strokeWidth: 0.9726,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1601 0.619141C21.3901 0.619141 18.3301 3.66914 18.3301 7.44914",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0054 35.211C64.93 32.0138 67.9986 23.91 64.8592 17.1107C61.7198 10.3115 53.5613 7.39152 46.6367 10.5888C39.7121 13.786 36.6436 21.8898 39.783 28.6891C42.9224 35.4883 51.0808 38.4083 58.0054 35.211Z",
    fill: "#3B5BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0757 33.3116C65.0003 30.1144 68.0689 22.0106 64.9295 15.2113C61.7901 8.41209 53.6316 5.4921 46.707 8.68936C39.7824 11.8866 36.7139 19.9904 39.8533 26.7896C42.9927 33.5889 51.1511 36.5089 58.0757 33.3116Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9404 25.7009C53.6604 26.9109 58.5204 24.1109 59.8204 19.4209",
    stroke: "white",
    strokeWidth: 1.3793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3772 19.5823C46.8084 19.3832 46.9985 18.8763 46.8017 18.4501C46.6049 18.0239 46.0958 17.8398 45.6646 18.0389C45.2334 18.238 45.0433 18.7449 45.2401 19.1711C45.4369 19.5973 45.946 19.7814 46.3772 19.5823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6155 13.7923C56.0467 13.5932 56.2368 13.0863 56.04 12.6601C55.8432 12.2339 55.3341 12.0498 54.9029 12.2489C54.4716 12.448 54.2816 12.9549 54.4784 13.3811C54.6752 13.8073 55.1843 13.9914 55.6155 13.7923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56 8.67073C105.92 8.81073 106.22 9.08073 106.38 9.46073L107.93 13.0007C108.26 13.7507 107.92 14.6307 107.16 14.9607C106.4 15.2907 105.53 14.9507 105.2 14.1907L103.65 10.6507C103.32 9.90073 103.66 9.02073 104.42 8.69073C104.79 8.52073 105.2 8.53073 105.56 8.67073Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.74 116.26L145.15 108",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 16.2598L141.89 25.9898",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 123.5L77.5 111.5",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 118.41L21.2997 112.84",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58984 54.8902L23.5298 52.6602",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceLeftImage);
export default __webpack_public_path__ + "static/media/scienceLeftImage.b3f9ef915f810bccc1d667766a525376.svg";
export { ForwardRef as ReactComponent };